export default __webpack_public_path__ + "static/media/f-08.db731b13.jpg";